import React from 'react';
import ChartBox from '../../Custom/ChartBox';
import ChartEnergyConsumptionForecast from './ChartEnergyConsumptionForecast';

const EnergyConsumptionForecast = ({ data }) => (
  <div>
    <ChartBox title={'Energy Consumption Forecast'}>
      <div id="EnergyConsumptionForecastContainer">
        <ChartEnergyConsumptionForecast data={data} />
      </div>
    </ChartBox>
  </div>
);

export default EnergyConsumptionForecast;
